import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { StoreProvider } from "./lib/store";
import "./styles.css";

const wurzel = document.getElementById("root");
if (!wurzel) throw new Error("Kein #root im HTML — index.html prüfen.");

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <StoreProvider>
        <App />
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>,
);
